import { Swiper, FreeMode } from 'swiper';
import { pushCtaEvent } from '@utils/dataLayer';
import { getAnalyticsContextFromElement, getAnalyticsSection } from '@utils/analyticsContext';

const CTA_SELECTOR = '.media-basic-text__cta';

function updateAccessibility(swiper, focusableElement) {
  const { isLocked } = swiper;

  if (isLocked) {
    focusableElement.removeAttribute('tabindex');
    focusableElement.removeAttribute('role');
  } else {
    focusableElement.setAttribute('tabindex', '0');
    focusableElement.setAttribute('role', 'region');
  }
}

export default function initMediaBasicTextSlider() {
  const mediaBasicTextBlocks = document.querySelectorAll('.media-basic-text');

  mediaBasicTextBlocks.forEach((block) => {
    const swiperContainer = block.querySelector('.media-basic-text__swiper.swiper');

    if (!swiperContainer || swiperContainer.swiper) {
      return;
    }

    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const isReversed = block.querySelector('.media-basic-text__container--reverse') !== null;
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const initialSlide = isReversed ? slides.length - 1 : 0;

    const swiperInstance = new Swiper(swiperContainer, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      loop: false,
      initialSlide,
      modules: [FreeMode],
      grabCursor: true,
      watchOverflow: true,
      freeMode: {
        enabled: true,
        momentum: false,
        momentumBounce: false,
      },

      on: {
        init: (swiper) => {
          // eslint-disable-next-line no-param-reassign
          swiper.allowTouchMove = !swiper.isLocked;
          swiperContainer.classList.toggle('swiper-grab-cursor', !swiper.isLocked);
          updateAccessibility(swiper, swiperWrapper);
          // eslint-disable-next-line no-use-before-define
          updateFocusWidth(swiper);
        },
        resize: (swiper) => {
          const targetSlide = isReversed ? swiper.slides.length - 1 : 0;
          requestAnimationFrame(() => {
            swiper.slideTo(targetSlide, 0);
          });
          // eslint-disable-next-line no-param-reassign
          swiper.allowTouchMove = !swiper.isLocked;
          swiperContainer.classList.toggle('swiper-grab-cursor', !swiper.isLocked);
          updateAccessibility(swiper, swiperWrapper);
          // eslint-disable-next-line no-use-before-define
          updateFocusWidth(swiper);
        },
        slidesLengthChange: (swiper) => {
          // eslint-disable-next-line no-use-before-define
          updateFocusWidth(swiper);
        },
      },
    });

    swiperContainer.mediaBasicTextSwiper = swiperInstance;

    function updateFocusWidth(swiper) {
      if (!swiperWrapper) return;
      const totalWidth = swiper.virtualSize;
      swiperWrapper.style.setProperty('--slider-total-width', `${totalWidth + 4}px`);
    }

    swiperContainer.addEventListener('keydown', (e) => {
      if (swiperInstance.isLocked) return;

      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();

        if (e.key === 'ArrowRight') {
          swiperInstance.slideNext();
        } else {
          swiperInstance.slidePrev();
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const target = event.target.closest(CTA_SELECTOR);
    if (target) {
      pushCtaEvent({
        section: getAnalyticsSection() || document.title || '',
        context: getAnalyticsContextFromElement(target),
        label: (target.textContent || '').trim(),
      });
    }
  });

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/media-basic-text', () => {
      initMediaBasicTextSlider();
    });
  } else {
    initMediaBasicTextSlider();
  }
});
